import React from 'react'
import { AuthContext } from '../../../contexts/AuthContext'
import DesktopCheckout from './DesktopCheckout'
import MobileCheckout from './MobileCheckout'
import { ValidPhone } from '../../Modais'
import { CheckoutContext } from '../../../contexts/CheckoutContext'

export default function Checkout() {
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { modaisChkt, actionsChkt } = React.useContext(CheckoutContext)

  React.useEffect(() => {
    document.title = 'Confirmar Pagamento | Agendei Quadras'
    // Verifica se o usuário não tem telefone cadastrado
  }, [])

  return (
    <>
      {modaisChkt.validPhone && (
        <ValidPhone
          show={modaisChkt.validPhone}
          onClose={() => actionsChkt.handleModaisChkt('validPhone', false)}
        />
      )}
      {sttAuthCtx.isMobile ? <MobileCheckout /> : <DesktopCheckout />}
    </>
  )
}
